import { Box, CircularProgress, Typography } from '@mui/material';
import React from 'react';
import { chartLoadingOverlayStyles } from './styles';
import type { ChartLoadingOverlayProps } from './types';

const ChartLoadingOverlay: React.FC<ChartLoadingOverlayProps> = React.memo(
  ({ isFetching }) => {
    if (!isFetching) {
      return null;
    }

    return (
      <Box sx={chartLoadingOverlayStyles.overlay}>
        <CircularProgress
          size={48}
          sx={chartLoadingOverlayStyles.progressSpinner}
        />
        <Typography variant='body1' sx={chartLoadingOverlayStyles.loadingText}>
          Refreshing data...
        </Typography>
      </Box>
    );
  },
);

ChartLoadingOverlay.displayName = 'ChartLoadingOverlay';

export default ChartLoadingOverlay;
